// extracted by mini-css-extract-plugin
export var chip = "_ml-2";
export var chipBody = "_ml-8";
export var chipHeader = "_ml-9";
export var chipWithKind = "_ml-7";
export var icon = "_ml-3";
export var kind = "_ml-a";
export var remove = "_ml-5";
export var removeIcon = "_ml-6";
export var row = "_ml-0";
export var rowHistorical = "_ml-1";
export var text = "_ml-4";